import { BaseTextFieldProps, StandardTextFieldProps, TextField, TextFieldProps } from '@mui/material';
import React from 'react';
interface CustomProps extends StandardTextFieldProps {
    name?: string;
    // onValidate?(value): boolean
    onValidateError?(value): string
    validated?: boolean

}
const TextFieldValidate = React.forwardRef<HTMLElement, CustomProps>(
    function TextFieldValidate(props, ref) {
        const { ...other } = props;
        const [validated, setValidated] = React.useState(false);



        React.useEffect(() => {
            if (props.validated != null) {
                setValidated(props.validated)
            }
        }, [props.validated]);
        // const isInvalid = React.useCallback(() => {
        //     let valid = validated && (props.required && (!props.value || props.value == "")) ? false : true
        //     if (props.onValidate) {
        //         valid = props.onValidate(props.value)
        //     }
        //     return valid
        // }, [props.value, validated]);


        const isError = (): string => {
            if (props.onValidateError) {
                return props.onValidateError(props.value)
            }

            return ""
        }

        const error = React.useMemo(() => {
            if (props.onValidateError) {
                return props.onValidateError(props.value)
            }
            return ""
        }, [props.value, validated]);

        return (
            <TextField

                {...other}
                inputRef={ref}

                onBlur={() => {
                    setValidated(true)
                }}
                error={(validated && error != "") ? true : false}
                helperText={validated && error != "" ? `${error}` : ""}
            />
        );
    },
);


export default TextFieldValidate
export { TextFieldValidate }